import { useQuery } from '@tanstack/react-query';
import { getSavedCards } from '../requests';
import { useCardPaymentSystems } from '../../model';
import { useMemo } from 'react';
import { getCardPaymentSystem } from '../../lib';

export function useGetSavedCards() {
  const { data: paymentSystems, isLoading } = useCardPaymentSystems();

  const query = useQuery({
    queryKey: ['operations/card/template'],
    queryFn: () => getSavedCards(),
    staleTime: 0,
    gcTime: 0,
    retry: 0,
  });

  const templates = useMemo(() => {
    const cards = query.data?.templates ?? [];

    return cards.map(card => {
      const system = getCardPaymentSystem(card.cardNumber, paymentSystems);

      return {
        ...card,
        cardType: system?.name,
        cardTypeIcon: system?.icon,
      };
    });
  }, [query.data?.templates, paymentSystems]);

  return {
    data: templates,
    isLoading: isLoading || query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}
